module.exports = __webpack_public_path__ + "static/media/collageTest.51d298bb.jpg";